import { render, staticRenderFns } from "./ShoppingList.vue?vue&type=template&id=22833d26&"
import script from "./ShoppingList.js?vue&type=script&lang=js&"
export * from "./ShoppingList.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ShoppingList.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fheader%2FShoppingList%2FShoppingList.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports